import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/images/completed.png'
import _imports_1 from '@/assets/images/round.png'


const _hoisted_1 = { class: "my-2" }
const _hoisted_2 = { class: "w-full table-fixed" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "px-4 py-2" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = {
  key: 0,
  class: "w-6 md:w-7",
  src: _imports_0,
  alt: "済"
}
const _hoisted_7 = {
  key: 1,
  class: "w-6 md:w-7",
  src: _imports_1,
  alt: "未済"
}
const _hoisted_8 = { class: "text-sm md:text-base font-medium text-gray-500 truncate ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (Array.isArray(_ctx.videos) && _ctx.videos.length)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "videoCategoryRef",
        class: "max-h-0 overflow-hidden duration-500 transition-all",
        style: _normalizeStyle(_ctx.switchHeightStyle)
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.videos, (video) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: video.id,
                onClick: ($event: any) => (_ctx.router.push({ name: 'VideoDetails', params: { video_id: video.id } })),
                class: _normalizeClass(["hover:bg-mentalncSuperLight hover:shadow-md cursor-pointer border border-slate-300", _ctx.switchColor(video.id)])
              }, [
                _createElementVNode("td", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (Array.isArray(video.video_completions) && video.video_completions.length)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                      : (_openBlock(), _createElementBlock("img", _hoisted_7)),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(video.title), 1)
                  ])
                ])
              ], 10, _hoisted_3))
            }), 128))
          ])
        ])
      ], 4))
    : _createCommentVNode("", true)
}